"use client";

import { Container } from "@/components/primitives/Container";
import { Eyebrow } from "@/components/primitives/Eyebrow";
import { getAbout } from "@/content/about";
import { useLocale } from "@/lib/i18n/provider";

/**
 * Vertical milestone rail. A single accent line runs down the left,
 * with dot markers aligned to each milestone.
 */
export function AboutTimeline() {
  const { locale } = useLocale();
  const about = getAbout(locale);

  return (
    <section className="relative py-20 md:py-28">
      <Container>
        <div className="max-w-[62ch]">
          <Eyebrow>{about.timeline.eyebrow}</Eyebrow>
          <h2 className="mt-4 text-[clamp(1.75rem,3.5vw,2.75rem)] font-bold leading-[1.08] tracking-[-0.025em] text-[var(--color-text-primary)]">
            {about.timeline.title}
          </h2>
        </div>

        <ol className="relative mt-12 ml-1 border-l border-[var(--color-surface-border)] pl-8">
          {about.timeline.items.map((m) => (
            <li key={m.year} className="relative pb-10 last:pb-0">
              <span
                aria-hidden
                className="absolute -left-[37px] top-1.5 h-3 w-3 rounded-full bg-[var(--color-accent-base)] ring-4 ring-[var(--color-bg-base)]"
              />
              <div className="text-[13px] font-medium uppercase tracking-[0.14em] text-[var(--color-accent-base)]">
                {m.year}
              </div>
              <h3 className="mt-2 text-xl font-semibold tracking-tight text-[var(--color-text-primary)]">
                {m.title}
              </h3>
              <p className="mt-2 max-w-[60ch] text-[15px] leading-relaxed text-[var(--color-text-secondary)]">
                {m.body}
              </p>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}

export default AboutTimeline;
